import { Helmet } from 'react-helmet-async';

interface Props {
    title: string;
    description: string;
    name: string;
    type: string;
    keywords?: string[];
    canonicalUrl?: string;
    imageUrl?: string;
    author?: string;
    structuredData?: Record<string, unknown>;
    lang?: string;
}

export default function SEO({
    title,
    description,
    name,
    type,
    keywords,
    canonicalUrl,
    imageUrl,
    author = "PrepBestie",
    structuredData,
    lang = "en"
}: Props) {
    // Default image URL if none provided
    const defaultImage = "https://prepbestie.com/prepbestie.png";
    const siteUrl = "https://prepbestie.com";

    // Build canonical URL if not explicitly provided
    const canonical = canonicalUrl || `${siteUrl}${window.location.pathname}`;

    return (
        <Helmet htmlAttributes={{ lang }}>
            {/* Standard metadata tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords?.join(', ')} />
            <meta name="author" content={author} />
            <link rel="canonical" href={canonical} />

            {/* Open Graph / Facebook tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:site_name" content="PrepBestie" />
            <meta property="og:image" content={imageUrl || defaultImage} />

            {/* Twitter tags */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={imageUrl || defaultImage} />

            {/* Mobile tags */}
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#4F46E5" />

            {/* Structured data for rich results */}
            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
}